module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Regular.93ba8a0d.eot";